(function () {
  function initCountdown(timer) {
    var minutes = Number(timer.dataset.minutes || 15);
    var storageKey = 's6-reasons-countdown-end-' + minutes;
    var now = Date.now();
    var end = Number(sessionStorage.getItem(storageKey));

    if (!end || end <= now) {
      end = now + minutes * 60 * 1000;
      sessionStorage.setItem(storageKey, String(end));
    }

    function render() {
      var remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
      var mins = Math.floor(remaining / 60);
      var seconds = remaining % 60;
      timer.textContent = String(mins).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');

      if (remaining <= 0) {
        end = Date.now() + minutes * 60 * 1000;
        sessionStorage.setItem(storageKey, String(end));
      }
    }

    render();
    window.setInterval(render, 1000);
  }

  function init() {
    document.querySelectorAll('[data-s6r-countdown]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
